<template>
	<div class="checkout-header">
		<div class="wrapper checkout-wrapper">
			<BaseCmsLogo class="logo" id="logo" />
			<BaseCmsLabel code="checkout_progressbar_title" tag="div" class="ch-step-title" v-if="mobileBreakpoint" />

			<div class="ch-step-right">
				<BaseCmsLabel code="checkout_progressbar_title" tag="div" class="ch-step-title" v-if="!mobileBreakpoint" />
				<div class="ch-step-progressbar">
					<span :style="'width:'+progress"></span>
				</div>
			</div>
	</div>
	</div>
	
</template>

<script setup>
	const props = defineProps({
		step: Number,
	});
	const {mobileBreakpoint} = inject('rwd');
	const progress = computed(() => {
		if (props?.step === 1) return '20%';
		if (props?.step === 2) return '40%';
		if (props?.step === 3) return '60%';
		if (props?.step === 4) return '80%';
		if (props?.step === 5) return '98%';
	});
</script>

<style lang="less" scoped>
	.checkout-header{
		position: relative; display: block; height: 80px; background-image: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(242, 245, 248, 1) 100%); border-bottom: 1px solid var(--gray);
		@media (max-width: @t){height: 60px;}
		@media (max-width: @m){height: auto; background: #fff;}	
	}
	.wrapper{
		display: flex; align-items: center; height: 100%; justify-content: space-between;
		@media (max-width: @m){flex-wrap: wrap; padding-top: 8px;}	
	}
	.logo{
		position: relative; display: block; width: 110px; height: 52px; background: url(assets/images/logo.svg) no-repeat; background-size: cover;
		@media (max-width: @t){width: 80px; height: 38px;}	
		@media (max-width: @m){margin-left: 16px; width: 83px; height: 40px;}
	}
	.ch-step-right{
		position: relative; display: flex; align-items: center; gap: 16px; width: 50%; padding-left: 100px;
		@media (max-width: @t){padding-left: 30px; gap: 12px;}	
		@media (max-width: @m){width: 100%; padding: 0; gap: 0;}
	}
	.ch-step-title{
		display: block; font-size: 16px; line-height: 1;
		@media (max-width: @t){font-size: 12px;}
		@media (max-width: @m){margin: 0 16px;}
	}
	.ch-step-progressbar{
		position: relative; display: block; width: 282px; background: var(--gray); border-radius: 4px; height: 8px;
		span{position: absolute; top: 0; left: 0; height: 8px; background: url(assets/images/bar.svg) repeat; border-radius: 4px; z-index: 10;}
		@media (max-width: @t){width: 215px;}
		@media (max-width: @m){
			width: 100%; padding: 0; border-radius: 0; margin-top: 8px;
			span{border-radius: 0;}
		}	
	}
</style>